export default __webpack_public_path__ + "static/pupper-photo-940ed6f4e952654b0a8d4775f033c882.jpg";